import { images } from './images';
import { photos } from './photos';

export const assets = {
  images,
  photos
};
